import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { labelActions } from '@common-reducers/labels-reducer';
import { Loader2 } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import LabelForm from '../label-input-with-emoji-picker';
import { newLabelThunk } from '@common-reducers/labels-reducer/labels-thunks/crud';
import { labelSelectByQuery } from "@common-reducers/DBServiceThunks";
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";


export default function AddNewLabelModalModal() {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const label = useAppSelector((state) => state.LabelReducer.label)
    const labels = useAppSelector((state) => labelSelectByQuery(state.DBLabelReducer, { type: 'custom' }))
    const isNewLabelModalOpen = useAppSelector((state) => state.LabelReducer.isNewLabelModalOpen)
    const labelNetWorkStatus = useAppSelector((state) => state.LabelReducer.labelNetWorkStatus)


    function isExisting(name: string) {
        const label = labels.find((_label) => _label.name === name)
        if (label) return label.name === name
    }

    const handleOpenChange = (open: boolean) => {
        dispatch(labelActions.toggleNewLabel(open))
    }

    return (
        <Dialog open={isNewLabelModalOpen} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md p-0 gap-0 overflow-hidden bg-white dark:bg-[var(--modal-bg)]" style={{ direction: "ltr" }}>
                <DialogHeader className="px-6 py-4 border-b border-zinc-100 dark:border-[var(--color-border)]">
                    <DialogTitle className="text-lg font-semibold text-zinc-900 dark:text-[var(--color-text)]">{t('labels.createCustomLabel')}</DialogTitle>
                </DialogHeader>

                <div className="px-6 py-4 space-y-4">
                    <LabelForm />

                    <div className="flex flex-wrap gap-2">
                        {getLabelSuggestions(t).map((sugestion, index) => {
                            const exists = isExisting(sugestion?.name ?? '')
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            const IconComponent = (LucideIcons as any)[sugestion.icon];

                            return (
                                <Button
                                    key={index}
                                    type="button"
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => {
                                        if (!exists) {
                                            dispatch(labelActions.setLabel(sugestion))
                                        }
                                    }}
                                    disabled={exists}
                                    className={cn(
                                        "rounded-full font-medium capitalize h-8 bg-gray-100/80 hover:bg-gray-200 text-gray-600 dark:bg-slate-700 dark:text-gray-300 dark:hover:bg-slate-600",
                                        exists && "opacity-50 cursor-not-allowed"
                                    )}
                                >
                                    <span className="mr-1">
                                        {IconComponent && <IconComponent size={14} />}
                                    </span>
                                    {sugestion.name}
                                </Button>
                            )
                        })}
                    </div>
                </div>

                <div className="px-6 pb-6">
                    <Button
                        onClick={() => dispatch(newLabelThunk())}
                        disabled={!label.name || labelNetWorkStatus === 'create-label'}
                        className="w-full gap-2 h-10 rounded-md font-medium bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-200 disabled:text-gray-400 dark:disabled:bg-slate-700 dark:disabled:text-gray-500"
                    >
                        {labelNetWorkStatus === 'create-label' ? (
                            <>
                                <Loader2 size={16} className="animate-spin" />
                                {t('labels.creating')}
                            </>
                        ) : (
                            t('common.create')
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

const getLabelSuggestions = (t: (key: string) => string) => [
    { icon: 'UserPlus', name: t('labels.suggestions.newLead') },
    { icon: 'HelpCircle', name: t('labels.suggestions.needsFollowUp') },
    { icon: 'FileText', name: t('labels.suggestions.invoiceSent') },
    { icon: 'CreditCard', name: t('labels.suggestions.paymentPending') },
    { icon: 'UserCheck', name: t('labels.suggestions.activeCustomer') },
    { icon: 'LifeBuoy', name: t('labels.suggestions.supportOpen') }
]